module.exports = __webpack_public_path__ + "static/media/phones-add-trade2.a8c5d674.png";